'use client';

import React from 'react';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import { DownIcon } from '@rescui/icons';

import IaButton from '@/components/common/webteam/IaButton/IaButton';
import IaDropdownMenu from '@/components/common/webteam/IaDropdownMenu/IaDropdownMenu';
import IaMenuItem from '@/components/common/webteam/IaMenuItem/IaMenuItem';
import IaTypography from '@/components/common/webteam/IaTypography/IaTypography';
import { DJANGO_ADMIN_URL } from '@/consts/common';
import { UserRole } from '@/enums/users';
import { useStores } from '@/hooks';

const DebugDropdown: React.FC = () => {
  const router = useRouter();
  const { userStore } = useStores();
  const me = userStore.me;

  const [isVisible, setVisible] = React.useState(false);

  const handleCloseDropdown = () => setVisible(false);
  const handleMenuClick = () => setVisible((isVisible) => !isVisible);

  const handleCompleteRegistration = () => {
    handleCloseDropdown();
    router.push('/register');
  };

  const handleExplicitSignInClick = () => {
    handleCloseDropdown();
    router.push('/debug/login');
  };

  return (
    <IaDropdownMenu
      isOpen={isVisible}
      minWidth="100px"
      theme="dark"
      trigger={
        <IaButton
          icon={<DownIcon />}
          iconPosition="right"
          mode="rock"
          theme="dark"
          onClick={handleMenuClick}
        >
          Debug
        </IaButton>
      }
      onRequestClose={handleCloseDropdown}
    >
      <IaTypography params={{ mode: 'clear' }} theme="dark" variant="rs-link">
        {me && me.role === UserRole.STUDENT && !me?.studentprofile && (
          <IaMenuItem onClick={handleCompleteRegistration}>
            Complete registration
          </IaMenuItem>
        )}

        <IaMenuItem onClick={handleExplicitSignInClick}>
          Explicit sign-in
        </IaMenuItem>

        {me?.role === UserRole.ADMIN && (
          <Link href={DJANGO_ADMIN_URL}>
            <IaMenuItem>Admin</IaMenuItem>
          </Link>
        )}
      </IaTypography>
    </IaDropdownMenu>
  );
};

export default observer(DebugDropdown);
